module.exports = __webpack_public_path__ + "assets/img/5.72a70232.jpg";